import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders, HttpErrorResponse} from '@angular/common/http';
import {httpOptions} from '../../../configurations/configuration';
import { environment } from '../../../../environments/environment';
import {Note} from '../../../models/event/note';
import { Observable } from 'rxjs/Observable';

@Injectable({
  providedIn: 'root'
})
export class NotesService {

  getNotesURL: string;
  addNotesURL: string;
  constructor(private http: HttpClient) {
    this.getNotesURL = environment.baseURI + environment.apiUrl + 'events/getEventNotes';
    this.addNotesURL = environment.baseURI + environment.apiUrl + 'events/addEventNotes';
  }
  getNotes(filterObj): Observable<Note> {
    return this.http.get<Note>(this.getNotesURL
        + '?filter=' + encodeURIComponent(JSON.stringify(filterObj)));
    }
    addNotesInfo(data): Observable<any> {
        return this.http.post<Note>(this.addNotesURL, data);
    }
}
